import { gql, useQuery } from '@apollo/client';
import { Skeleton } from '@arcadiapower/shrike';
import { useState } from 'react';
import { ErrorMessage } from '~/components/error-message';
import { Container } from '~/components/layout';
import { Link } from '~/components/link';
import { TermsText } from '~/components/terms/terms-text';
import { OnChange, ValidatingInput } from '~/components/validating-input';
import { LDClient, LDFlags } from '~/providers';
import { ARCADIA_REWARDS_URL } from '~/utils/constants';

export const FETCH_TERMS = gql`
  query Flex_FetchGeneralTerms {
    generalContractVersions(contractType: [privacy, terms]) {
      id
      displayName
    }
  }
`;

const rewardsLink = ARCADIA_REWARDS_URL;

type GeneralProps = {
  onChange: OnChange<number[]>;
};

export const GeneralTerms = ({ onChange }: GeneralProps) => {
  const { data, loading, error } = useQuery(FETCH_TERMS);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const contracts = data?.generalContractVersions || [];
  const ids = contracts.map(contract => contract.id);

  const showRewardsGuidelines = LDClient.variation(LDFlags.showRewardsGuidelines);

  if (error) {
    return (
      <ErrorMessage
        allow
        error="There was a problem loading our terms. Please refresh the page to try again."
      />
    );
  } else if (loading) {
    return (
      <Container>
        <Skeleton backgroundColor="tertiary" width="100%" />
        <Skeleton backgroundColor="tertiary" width="100%" />
      </Container>
    );
  } else {
    const pretext = !showRewardsGuidelines ? (
      <span>By checking this box, I agree to Arcadia’s</span>
    ) : (
      <span>
        When you register, you are automatically enrolled in our{' '}
        <Link
          id="rewardsLink"
          openInNewTab={false}
          onClick={() => window.open(rewardsLink, '_blank')}
          color="secondary"
        >
          Arcadia Rewards Program
        </Link>
        . By checking this box, you acknowledge you have read and agree to Arcadia's
      </span>
    );
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flexDirection: 'row',
        }}
      >
        <ValidatingInput
          type="checkbox"
          id="generalTerms"
          label=""
          name="generalTerms"
          checked={isTermsAccepted}
          value={isTermsAccepted}
          validate={() => isTermsAccepted}
          onChange={value => {
            setIsTermsAccepted(!!value);
            onChange(ids, { name: 'generalContractIds', isValid: !!ids.length && !!value });
          }}
        />
        <TermsText contracts={contracts} postText="." preText={pretext} textAlign="left" />
      </div>
    );
  }
};
